import { render, staticRenderFns } from "./NewEmailDialog.vue?vue&type=template&id=2423b6d1&scoped=true"
import script from "./NewEmailDialog.vue?vue&type=script&lang=js"
export * from "./NewEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423b6d1",
  null
  
)

export default component.exports